<template>
    <div class="stepsDetail">
        <div id="amapContainer" style="width:100vw;height:100vh;"></div>
        <div class="header">
            <van-image :src="userInfo.userInfo.avatarurl"></van-image>
            <span>
            <ICountUp :endVal="userTaskInfo.totalSteps*1"/>
         </span>
         <span>自  {{userTaskInfo.join_start_time}}起累计</span>
        </div>
        <div class="rules" @click="rulesShow=true">
            <img src="@/assets/img/steps/rules.png" alt/>
        </div>
        <div class="footer">
            <div>
                <span>{{userTaskInfo.currentFinished}}</span>
                已点亮点位
            </div>
            <div @click="handleSteps">
                <a v-if="userTaskInfo.currentFinished<21">点亮</a>
                <a v-else style="font-size:.4rem;">
                    下载
                    <br/>证书
                </a>
            </div>

            <div>
                <div>
                    <span>{{freenum}}</span>
                    抽奖机会
                </div>
                <img src="@/assets/img/steps/draw.png" alt @click="goluckdraw"/>
            </div>
        </div>

        <van-dialog
                v-model="rulesShow"
                title="活动规则"
                :style="{width:'80vw' }"
                round
                close-on-click-overlay
        >
            <div style="padding:0rem;overflow: scroll;height:40vh;" v-html="detail.intro"></div>
        </van-dialog>

        <Popup
                v-model="pointShow"
                get-container="#app"
                :style="{ width: '80%',overflowY:'inherit' }"
                round
                close-on-click-overlay
                @closed="closepointShow"
        >
            <div class="pointDesc">
                <div id="fireworks" v-if="activityPoints.playerInfo!=null && activityPoints.id==137">
                    <img src="@/assets/img/steps/fire/1.png" alt="">
                    <img src="@/assets/img/steps/fire/2.png" alt="">
                    <img src="@/assets/img/steps/fire/3.png" alt="">
                    <img src="@/assets/img/steps/fire/4.png" alt="">
                    <img src="@/assets/img/steps/fire/5.png" alt="">
                </div>
                <van-image :src="activityPoints.imgurl" width="2.2rem" fit="contain">
                    <template v-slot:loading>
                        <Loading type="spinner" size="20" />
                    </template>
                </van-image>
                <div>
                    <header>
                        <div v-if="activityPoints.playerInfo!=null && activityPoints.id!=137" style="margin-bottom: .2rem;">恭喜您点亮</div>
                        <div class="headertitle">{{activityPoints.title}}</div>
                    </header>
                    <div class="shortdesc">{{activityPoints.shortdesc}}</div>
                    <div class="jiao">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>

                    <div class="intro" v-if="activityPoints.description">
                        <div class="introtitle">
                            <template v-if="activityPoints.id==137"></template>
                            <template v-else>点位介绍</template>
                        </div>
                        <div :style="{display:showMore?'block':'-webkit-box'}"> {{activityPoints.description}}</div>
                        <van-icon name="arrow-down" color="#999" @click="showMore=true" v-if="!showMore && activityPoints.description.length>=40"/>
                        <van-icon name="arrow-up" color="#999" @click="showMore=false" v-if="showMore && activityPoints.description.length>=40"/>
                    </div>

                    <footer style="margin-top:10px;color:#393940;font-size: .3rem;"
                            v-if="activityPoints.msg && activityPoints.futurecan*1">
                        您还可以继续点亮 <span style="color: #FF5D4B">{{activityPoints.futurecan}}</span>个地标<br>是否继续点亮?
                    </footer>

                    <div class="button" @click="handleSteps" v-if="activityPoints.futurecan*1">继续点亮</div>

                    <div  style="color:#999;font-size: .3rem;margin-top:10px;"  @click="pointShow=false" v-if="activityPoints.futurecan*1">
                        取消
                    </div>
                    <div class="button" @click="pointShow=false" v-else>
                       确定
                    </div>

                </div>
            </div>
        </Popup>
    </div>
</template>
<script>
    var points = [
        [[121.493356,31.200089],[121.494587,31.200449,121.49529,31.201003,121.495226,31.201729],[121.494796,31.202443]],
        [[121.494796,31.202443],[121.493418,31.203417,121.491529,31.203836,121.489846,31.203115],[121.488657,31.202153]],
        [[121.488657,31.202153],[121.486877,31.201201,121.48266,31.202759,121.483126,31.202478],[121.482393,31.202926,121.482204,31.203482,121.482406,31.204013],[121.48291,31.204432]],
        [[121.48291,31.204432],[121.484222,31.205742,121.484908,31.206368,121.484555,31.207578],[121.483664,31.208117]],
        [[121.483664,31.208117],[121.483192,31.209295,121.484499,31.210578,121.485397,31.211006],[121.486643,31.211149,121.487574,31.211137,121.488801,31.210835],[121.489679,31.210481]],
        [[121.489679,31.210481],[121.490236,31.21028,121.490942,31.21018,121.491486,31.21015],[121.491918,31.210182,121.492439,31.210228,121.493088,31.210243],[121.493597,31.210351,121.494124,31.210499,121.494593,31.210691],[121.495185,31.210807],[121.495695,31.21068]],
        [[121.495695,31.21068],[121.496718,31.210519,121.497471,31.21035,121.498018,31.209629],[121.498589,31.208245]],
        [[121.498589,31.208245],[121.498489,31.207205,121.49839,31.206915,121.498486,31.206227],[121.49878,31.20571,121.49931,31.205209,121.500462,31.204466],[121.501529,31.203998]],
        [[121.501529,31.203998],[121.502015,31.201663,121.501827,31.200375,121.500575,31.199104],[121.498305,31.198123]],
        [[121.498305,31.198123],[121.499642,31.197508,121.500325,31.197075,121.500425,31.19644],[121.500015,31.195131]],
        [[121.500015,31.195131],[121.499883,31.194573,121.499266,31.194241,121.498428,31.193971],[121.497492,31.193763,121.496582,31.193671,121.4957,31.193709],[121.494382,31.193681,121.493044,31.193749,121.492514,31.193772],[121.491947,31.193849,121.491446,31.193921,121.490834,31.193908],[121.490134,31.194011]],
        [[121.490134,31.194011],[121.489506,31.193911,121.488956,31.193629,121.488824,31.193127],[121.488879,31.192536,121.489016,31.192034,121.489378,31.191448],[121.489643,31.191128,121.48995,31.19068,121.490286,31.190397],[121.490511,31.190229,121.490854,31.190045,121.491313,31.189839],[121.492726,31.189545]],
        [[121.492726,31.189545],[121.493347,31.189306,121.493847,31.189004,121.49413,31.188731],[121.494402,31.188487,121.494775,31.188167,121.495033,31.187794],[121.495498,31.187169,121.49557,31.186794,121.495683,31.186375],[121.495763,31.18587,121.49583,31.185269,121.495858,31.184805],[121.495855,31.184277],[121.495825,31.184049],[121.495645,31.182584]],
        [[121.495645,31.182584],[121.493898,31.181522,121.49318,31.181417,121.492089,31.181415],[121.491334,31.18146,121.490672,31.181621,121.490154,31.181811],[121.489714,31.182052,121.489373,31.182216,121.48903,31.182332],[121.488359,31.182761]],
        [[121.488359,31.182761],[121.487818,31.183128,121.487592,31.183469,121.48731,31.183955],[121.487096,31.184521,121.486908,31.184934,121.486777,31.185306],[121.486629,31.185655,121.486449,31.185959,121.486287,31.186286],[121.486021,31.186543,121.485653,31.186639],[121.485128,31.186844],],
        [[121.485128,31.186844],[121.484658,31.186794,121.483894,31.186791,121.483304,31.186731],[121.482411,31.186597,121.481741,31.18652],[121.481174,31.1866],],
        [[121.481174,31.1866],[121.480715,31.186813,121.48042,31.186914,121.480154,31.187308],[121.479982,31.187761,121.480024,31.188146,121.480131,31.188466],[121.480271,31.188739,121.480471,31.188984,121.480585,31.189294],[121.481067,31.189774]],
        [[121.481067,31.189774],[121.481672,31.190111,121.481905,31.190289,121.482332,31.190595],[121.482649,31.190829,121.482891,31.19107,121.483084,31.191299],[121.483294,31.191555,121.483536,31.191958],[121.483616,31.192239]],
        [[121.483616,31.192239],[121.483654,31.192605,121.483639,31.192912,121.483669,31.193273],[121.483654,31.193589,121.483618,31.193962,121.483591,31.194287],[121.48336,31.195614],[121.48336,31.195614]],
        [[121.48336,31.195614],[121.483446,31.197235,121.483627,31.197596,121.484298,31.197924],[121.484298,31.197924],[121.487373,31.198905]],
        [[121.487373,31.198905],[121.493356,31.200089]]];
    var offset = [
        [10, -55], //1
        [-60, -85], //2
        [-95, -40],//3
        [-80, -50],//4
        [-30, -80],//5
        [-25, -85],//6
        [10, -45],//7
        [0, -50],//8
        [-80, -50],//8
        [10, -50],//10
        [0, 0],//11
        [-55, 10],//12
        [-30, 0], //13
        [-30, 10],  //14
        [-50, 15], //15
        [-60, 0],
        [-90, -50],
        [0, -20],
        [-90, -30],
        [-10, 0],
        [-50, -50],
    ];
    var offset14 = [
        [0, -50], //1
        [-30, -65], //2
        [-70, -20],//3
        [-60, -30],//4
        [-20, -60],//5
        [-25, -65],//6
        [10, -45],//7
        [10, -30],//8
        [-50, -30],//9
        [20, -30],//10
        [0, 0],//11
        [-55, 10],//12
        [-20, 10], //13
        [-30, 10],  //14
        [-35, 5], //15
        [-40, 0],
        [-60, -30],
        [5, -10],
        [-60, -20],
        [-5, 5],
        [-30, -30],
    ];


    var arr = [];
    import {mapGetters} from "vuex";
    import PinchZoom from "vue-pinch-zoom";
    import {Button, Image, Loading, Swipe, SwipeItem, Popup, Collapse, CollapseItem} from "vant";
    import Footbar from "@/components/footbar/index";
    import ICountUp from "vue-countup-v2";
    import {lazyAMapApiLoaderInstance} from "vue-amap";
    import moment from 'moment';

    const STEPS_COUNT = 8000;
    const JACKPOT = 802;
    export default {
        name: "checkDetail",
        computed: {
            ...mapGetters({
                userInfo: "getUserInfo"
            })
        },
        data() {
            return {
                showMore:false,
                activityPoints:{},
                collapsename: [],
                point: [],
                pointShow: false,
                pointShowFrom: 1,
                rulesShow: false,
                userTaskInfo: {
                    currentFinished: 0,
                    totalSteps: 0
                },
                sigining: false,
                freenum: 0,
                detail: {
                    intro: ""
                },
                markers:[],
                markers14:[],
            };
        },
        components: {
            Button,
            VanImage: Image,
            Footbar,
            Loading,
            Swipe,
            SwipeItem,
            ICountUp,
            Popup,
            PinchZoom,
            Collapse,
            CollapseItem
        },
        methods: {
            handleSteps() {
                if (this.userTaskInfo.currentFinished >= this.point.length) {
                    this.$api.activity
                        .getCert({id: this.$route.params.activity_id})
                        .then(res => {
                            wx.previewImage({
                                urls: [res.data.cert]
                            });
                        });
                    return;
                }

                if (this.sigining) return;
                this.sigining = true;
                this.$toast.loading("处理中...");
                this.$api.steps.stepsCheckin(Object.assign({api_throw_exception: false}, this.$route.params)).then(
                    res => {

                        this.sigining = false;
                        this.$toast.clear();
                        if (+res.status !== 200) {
                            this.$toast({
                                type: 'html',
                                position: "bottom",
                                message: "<div style='display: flex;align-items: center;font-size:12px;'>" +
                                    "<img src='" + require("@/assets/img/steps/run.png") + "' style='width:.44rem;height:.44rem;margin-right: 5px;'>" + res.message + "</div>",
                                duration: 5000,
                                className: "bottomToast"
                            })

                            return;
                        }

                        let {finided, betweenSteps} = res.data;
                        this.activityPoints = Object.assign(finided,{playerInfo:{}});
                        if (!this.pointShow) this.pointShow = true;
                        this.userTaskInfo.totalSteps = betweenSteps;
                        this.activityDetail();
                        this.getTaskList();

                    },
                    () => {

                    }
                );
            },

            getTaskList() {
                let that = this;
                new Promise(function (resolve, reject) {
                    //先清除所有的marker
                    that.map.remove(that.markers14)
                    that.map.remove(that.markers);
                    that.$api.activity.taskList(that.$route.params).then(res => {
                        if (res.status * 1 === 200) {
                            var {subList, intro, title} = res.data;
                            var currentFinished = 0;

                            var finshedLine = [];
                            var finshedfirstpoint = [];
                            var markers = [];
                            var markers14 = [];

                            subList.forEach((item, index) => {
                                if (!!item.playerInfo) {
                                    currentFinished++;
                                    var icon = new AMap.Icon({
                                        size: new AMap.Size(80, 80),    // 图标尺寸
                                        image: item.icon,
                                        imageSize: new AMap.Size(80, 80),   // 根据所设置的大小拉伸或压缩图片
                                    });
                                    var marker = new AMap.Marker({
                                        position: points[index][points[index].length - 1],
                                        icon: icon, // 添加 Icon 实例
                                        offset: new AMap.Pixel(offset[index][0], offset[index][1]), //设置偏移量
                                        anchor: 'bottom-left', // 设置锚点方位
                                        title: index,
                                        zIndex:1000
                                    });

                                    marker.on('click', function (e) {
                                        that.markerClick(e)
                                    })


                                    var icon14 = new AMap.Icon({
                                        size: new AMap.Size(50,50),    // 图标尺寸
                                        image: item.icon,
                                        imageSize: new AMap.Size(50, 50),   // 根据所设置的大小拉伸或压缩图片
                                    });
                                    var marker14 = new AMap.Marker({
                                        position: points[index][points[index].length - 1],
                                        icon: icon14, // 添加 Icon 实例
                                        offset: new AMap.Pixel(offset14[index][0], offset14[index][1]), //设置偏移量
                                        anchor: 'bottom-left', // 设置锚点方位
                                        title: index,
                                        zIndex:1000
                                    });

                                    marker14.on('click', function (e) {
                                        that.markerClick(e)
                                    })


                                    var content = '<div class="first-point activity">' + (index+1) + "</div>";
                                    finshedfirstpoint.push(
                                        new AMap.Marker({
                                            position: points[index][points[index].length - 1],
                                            content,
                                            offset: new AMap.Pixel(-12.5,-12.5), //设置偏移量
                                            anchor: 'bottom-left', // 设置锚点方位
                                            zooms: [14,16],
                                            zoom: 15,
                                        })
                                    );

                                    finshedLine = finshedLine.concat(points[index])
                                } else {
                                    var icon = new AMap.Icon({
                                        size: new AMap.Size(80, 80),    // 图标尺寸
                                        image: "https://oss.mcloud.moveclub.cn/mcloud/xuhui/v2/point_gray_v7/" + (index + 1) + ".png",
                                        imageSize: new AMap.Size(80, 80),   // 根据所设置的大小拉伸或压缩图片
                                    });

                                    var marker = new AMap.Marker({
                                        position: points[index][points[index].length - 1],
                                        icon: icon, // 添加 Icon 实例
                                        offset: new AMap.Pixel(offset[index][0], offset[index][1]), //设置偏移量
                                        anchor: 'bottom-left', // 设置锚点方位
                                        title: index,
                                        zooms: [14,16],
                                        zoom: 15,
                                        zIndex:999

                                    });

                                    AMap.event.addListener(marker,'click',that.markerClick);

                                    marker.on('click', function (e) {
                                        that.markerClick(e)
                                    })



                                    var icon14 = new AMap.Icon({
                                        size: new AMap.Size(50, 50),    // 图标尺寸
                                        image: "https://oss.mcloud.moveclub.cn/mcloud/xuhui/v2/point_gray_v7/" + (index + 1) + ".png",
                                        imageSize: new AMap.Size(50, 50),   // 根据所设置的大小拉伸或压缩图片
                                    });
                                    var marker14 = new AMap.Marker({
                                        position: points[index][points[index].length - 1],
                                        icon: icon14, // 添加 Icon 实例
                                        offset: new AMap.Pixel(offset14[index][0], offset14[index][1]), //设置偏移量
                                        anchor: 'bottom-left', // 设置锚点方位
                                        title: index,
                                        zIndex:1000
                                    });

                                    marker14.on('click', function (e) {
                                        that.markerClick(e)
                                    })
                                }
                                markers.push(marker);
                                markers14.push(marker14);
                            });
                            // 已经完成的创建折线实例
                            if(finshedLine.length>0){
                                var polyline = new AMap.BezierCurve({
                                    path: finshedLine,
                                    lineJoin: "round",
                                    lineCap: "round",
                                    strokeWeight: 1,
                                    strokeColor: "#FFFFFF",
                                    outlineColor: "#FF5D51",
                                    borderWeight: 4,
                                    isOutline: true,
                                    strokeStyle: "dashed"
                                });
                                polyline.setMap(that.map)
                            }
                            //
                            that.markers = markers;
                            that.markers14 = markers14;

                            var zoom = that.map.getZoom()
                            if(zoom==14){
                                that.map.add(markers14)
                            }else{
                                that.map.add(markers);
                            }
                            that.map.add(finshedfirstpoint);
                            that.point = res.data.subList;
                            that.detail = {intro, title};
                            that.userTaskInfo.currentFinished = currentFinished;
                            that.userTaskInfo.join_start_time = moment(res.data.start_time*1000).format('MM月DD日');
                            let index = currentFinished - 1 <= 0 ? 0 : currentFinished - 1
                            index = index + 1 >= 20 ? 20 : (index + 1)
                            that.map.setCenter(
                                points[index][0]
                            );
                            resolve(Object.assign(res.data, {currentFinished}));
                        }
                    });
                }).then(e => {
                    let {start_time, end_time} = e;
                    that.$api.steps.stepsInfo({start_time, end_time}).then(res => {
                        if (+res.status === 200) {
                            let totalSteps = +res.data;
                            this.userTaskInfo = Object.assign(this.userTaskInfo, {
                                totalSteps
                            });
                        }
                    });
                });
            },
            activityDetail: function () {
                this.$api.activity.activityDetail({acid: JACKPOT}).then(res => {
                    this.freenum = res.data.freenum;
                });
            },
            goluckdraw: function () {
                this.$router.push({name: "luckdraw", params: {acid: JACKPOT}});
            },
            markerClick: function (e) {
                if(+e.target.getTitle()===20 && this.userTaskInfo.currentFinished<21){

                    this.$dialog.alert({
                        title: '提示',
                        width:'80vw',
                        message: '您还未走完本次活动的其他点位。\r\n完成所有任务后可查看该点位详情！',
                    }).then(() => {
                        // on close
                    });
                    return ;
                }


                this.activityPoints = this.point[e.target.getTitle()];
                this.pointShow = true;
                this.pointShowFrom = 2;
            },
            closepointShow: function () {
                this.pointShowFrom = 1;
                this.collapsename = []
                this.activityPoints= {}
            }
        },
        mounted() {
            // this.$nextTick(() => {
            lazyAMapApiLoaderInstance.load().then(() => {
                var imageLayer = new AMap.ImageLayer({
                    url: "https://oss.mcloud.moveclub.cn/mcloud/xuhui/v2/17191593420782_.pic_hd.jpg",
                    bounds : new AMap.Bounds(
                        [121.461777,31.163559], [121.524253,31.227726]
                    ),
                    zooms: [14,16],
                    zoom: 15,
                    opacity:.5
                });
                let layer_std = new AMap.TileLayer();
                this.map = new AMap.Map("amapContainer", {
                    resizeEnable: true,
                    center: [121.491708,31.196219],
                    zooms: [14,16],
                    zoom: 14,
                    layers: [layer_std, imageLayer],
                    mapStyle: "amap://styles/whitesmoke",
                });

                this.map.remove(layer_std);
                var linePoint = [];
                var firstPointMarkers = [];
                points.forEach((item, index) => {
                    linePoint = linePoint.concat(item);
                    var content = '<div class="first-point">' + index + "</div>";
                    if (index) {
                        firstPointMarkers.push(
                            new AMap.Marker({
                                position: item[0],
                                content,
                                animation:"AMAP_ANIMATION_DROP",
                                offset: new AMap.Pixel(-12.5,-12.5), //设置偏移量
                                anchor: 'bottom-left', // 设置锚点方位
                            })
                        );
                    }

                });
             //限制范围
                var bounds = new AMap.Bounds(
                    [121.461521,31.165198], [121.524464,31.22753]
                )
                this.map.setLimitBounds(bounds);
                this.map.add(firstPointMarkers);
                var that = this;
                setTimeout(() => {
                    var polyline = new AMap.BezierCurve({
                        path: linePoint,
                        lineJoin: "round",
                        lineCap: "round",
                        strokeWeight: 1,
                        strokeColor: "#FFFFFF",
                        outlineColor: "#999999",
                        borderWeight: 4,
                        isOutline: true,
                        strokeStyle: "dashed"
                    });
                    polyline.setMap(that.map)
                    that.getTaskList();
                    that.activityDetail();
                }, 1)

                this.map.setFeatures("building")

                this.map.on("click",function (e) {
                    console.log(e);
                })

                this.map.on('zoomend',function (e) {
                    var zoom = that.map.getZoom()
                    if(zoom==14){
                        that.map.remove(that.markers);
                        that.map.add(that.markers14)
                    }else{
                        that.map.remove(that.markers14)
                        that.map.add(that.markers);
                    }

                })



            });

            // })

        }
    };
</script>
<style lang="less">
    @import "Detail.less";
</style>
